import React, { useCallback, useEffect, useState } from "react";
import aiDevelopmentService from "../../services/aiDevelopmentService";

export default function AiTaigaStorySyncPanel({ storyId, originSystem, t }) {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      setStatus(await aiDevelopmentService.storyTaigaStatus(storyId));
    } catch {
      setStatus(null);
    }
  }, [storyId]);

  useEffect(() => {
    load();
  }, [load]);

  if (!status || !status.taigaUrl) return null;

  const run = async (fn) => {
    setBusy(true);
    setError("");
    try {
      await fn();
      await load();
    } catch (e) {
      setError(e?.message || t("common.errorOccurred"));
    } finally {
      setBusy(false);
    }
  };

  const resolve = (conflictId, resolution) =>
    run(() => aiDevelopmentService.resolveTaigaConflict(conflictId, { resolution }));

  return (
    <div className="ai-taiga-sync-panel">
      <h3>{t("aiDevelopment.taigaSync.storyTitle")}</h3>
      {error && <div className="ai-studio-alert">{error}</div>}
      <div className="ai-taiga-sync-status">
        <span>{t("aiDevelopment.taigaSync.storyOrigin")}: {t(`aiDevelopment.taigaSync.origin${originSystem === "TAIGA" ? "Taiga" : "Idax"}`)}</span>
        <span className="ai-status">{t(`aiDevelopment.taigaSync.linkStatus${status.linkStatus}`)}</span>
        {status.lastSyncedAt && (
          <span>{t("aiDevelopment.taigaSync.lastSynced")}: {new Date(status.lastSyncedAt).toLocaleString()}</span>
        )}
        {status.lastError && <span className="ai-status ai-status-error">{status.lastError}</span>}
        {status.filteredReason && <span className="ai-status ai-status-error">{status.filteredReason}</span>}
      </div>
      <div className="ai-actions">
        <button type="button" className="btn btn-default" disabled={busy} onClick={() => run(() => aiDevelopmentService.retryTaigaSync(storyId))}>
          {t("aiDevelopment.taigaSync.retry")}
        </button>
        {status.linkStatus === "FILTERED" ? (
          <button type="button" className="btn btn-default" disabled={busy} onClick={() => run(() => aiDevelopmentService.includeInTaigaSync(storyId))}>
            {t("aiDevelopment.taigaSync.include")}
          </button>
        ) : (
          <button type="button" className="btn btn-default" disabled={busy} onClick={() => run(() => aiDevelopmentService.excludeFromTaigaSync(storyId))}>
            {t("aiDevelopment.taigaSync.exclude")}
          </button>
        )}
      </div>
      {status.pendingConflicts?.length > 0 && (
        <div className="ai-taiga-sync-conflicts">
          <h4>{t("aiDevelopment.taigaSync.conflictsTitle")}</h4>
          {status.pendingConflicts.map((c) => (
            <div className="ai-taiga-sync-conflict" key={c.id}>
              <strong>{c.fieldName}</strong>
              <div className="ai-taiga-sync-conflict-values">
                <span>{t("aiDevelopment.taigaSync.idaxValue")}: {c.idaxValue}</span>
                <span>{t("aiDevelopment.taigaSync.taigaValue")}: {c.taigaValue}</span>
              </div>
              <div className="ai-actions">
                <button type="button" className="btn btn-default" onClick={() => resolve(c.id, "RESOLVED_IDAX")}>
                  {t("aiDevelopment.taigaSync.resolveIdax")}
                </button>
                <button type="button" className="btn btn-default" onClick={() => resolve(c.id, "RESOLVED_EXTERNAL")}>
                  {t("aiDevelopment.taigaSync.resolveTaiga")}
                </button>
                <button type="button" className="btn btn-default" onClick={() => resolve(c.id, "RESOLVED_MANUAL")}>
                  {t("aiDevelopment.taigaSync.resolveManual")}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
